module.exports = __webpack_public_path__ + "img/home1.9b28b1ad.jpg";